.btn {
    font-size: 1em;
    font-weight: 500;
    border-width: 2px;
    border-style: solid;
    border-radius: 20px;
    padding: 10px 26px;
    transition: opacity 0.2s ease-in-out;
    border-color: var(--color-btn-second);
    color: var(--color-btn-second);
    background-color: var(--color-btn-bg-second);
}

.btn:not(:disabled):hover {
    background-color: var(--color-btn-bg-second-hover);
    color: var(--color-btn-second-hover);
}

.btn:disabled {
    opacity: .3;
    cursor: not-allowed;
}

.btn:disabled:hover {
    background-color: transparent;
}

.btnActive {
    color: var(--color-btn-second-active);
    border-color: var(--color-btn-bg-second-active);
    background-color: var(--color-btn-bg-second-active);
}



